import React from "react";

import { Check } from "icons";

import { Steward } from "components/Common/TableStyle";

export const DATA_SOURCE_BUSINESS_TERM_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "60%",
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    width: "45%",
    render: row => <Steward name={row?.name} role={row?.role} />,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    width: "45%",
    render: row => <Steward name={row?.name} role={row?.role} />,
  },
];

export const ASSOCIATE_BUSINESS_TERM_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "60%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const DATA_SOURCE_BUSINESS_TERM_DUMMY_ROWS = [
  {
    name: "Medical Degree",
    description: "The school that issued the providers medical degree",
    drafter: "Donna Data Steward",
    approver: "Ian Info Governor",
  },
];

export const ASSOCIATE_BUSINESS_TERM_ROWS = [
  { id: 1, name: "Sample 1", description: "Sample 1 description" },
  { id: 2, name: "Sample 2", description: "Sample 2 description" },
];
